/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MathDeltaIcon16Light } from './MathDeltaIcon16Light';
import { MathDeltaIcon16Regular } from './MathDeltaIcon16Regular';
import { MathDeltaIcon16Solid } from './MathDeltaIcon16Solid';
import { MathDeltaIcon20Light } from './MathDeltaIcon20Light';
import { MathDeltaIcon20Regular } from './MathDeltaIcon20Regular';
import { MathDeltaIcon20Solid } from './MathDeltaIcon20Solid';
import { MathDeltaIcon24Regular } from './MathDeltaIcon24Regular';
import { MathDeltaIcon24Solid } from './MathDeltaIcon24Solid';
import { MathDeltaIcon32Regular } from './MathDeltaIcon32Regular';
import { MathDeltaIcon64Regular } from './MathDeltaIcon64Regular';
var sizes = {
    16: {
        light: MathDeltaIcon16Light,
        regular: MathDeltaIcon16Regular,
        solid: MathDeltaIcon16Solid,
    },
    20: {
        light: MathDeltaIcon20Light,
        regular: MathDeltaIcon20Regular,
        solid: MathDeltaIcon20Solid,
    },
    24: {
        regular: MathDeltaIcon24Regular,
        solid: MathDeltaIcon24Solid,
    },
    32: {
        regular: MathDeltaIcon32Regular,
    },
    64: {
        regular: MathDeltaIcon64Regular,
    },
};
export var MathDeltaIcon = forwardRef('MathDeltaIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
